import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { publicApiMethods } from '@/services/api'
import type { User, UserCredentials } from '@/models/user'

export const useAuthStore = defineStore('auth', () => {
  // État
  const user = ref<User | null>(null)
  const token = ref<string | null>(null)

  // Getters
  const isAuthenticated = computed(() => !!token.value)
  const isAdmin = computed(() => user.value?.role === 'admin')
  const isEmployee = computed(() => user.value?.role === 'employee')

  // Actions
  const login = async (credentials: UserCredentials) => {
    try {
      const response = await publicApiMethods.login(credentials)
      const { token: newToken, user: userData } = response.data

      // Stocker le token et les informations utilisateur
      token.value = newToken
      user.value = userData
      localStorage.setItem('token', newToken)

      return userData
    } catch (error) {
      console.error('Login error:', error)
      throw error
    }
  }

  const logout = async () => {
    // Nettoyer l'état
    user.value = null
    token.value = null
    localStorage.removeItem('token')
  }

  const initAuth = async () => {
    const storedToken = localStorage.getItem('token')
    if (storedToken) {
      token.value = storedToken
      try {
        const response = await publicApiMethods.getProfile()
        user.value = response.data
      } catch (error) {
        console.error('Error initializing auth:', error)
        await logout()
      }
    }
  }

  return {
    // État
    user,
    token,

    // Getters
    isAuthenticated,
    isAdmin,
    isEmployee,

    // Actions
    login,
    logout,
    initAuth
  }
}) 